import { useEffect } from "react";

/**
 * Use fullscreen height
 */
export function useFullScreen() {
    useEffect(() => {
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty("--vh", `${vh}px`);

        window.addEventListener("resize", () => {
            vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty("--vh", `${vh}px`);
        });
    }, []);

    return "calc(var(--vh, 1vh) * 100)";
}
